import { X, ArrowRight } from 'lucide-react';
import { Button } from './ui/button';
import { CreditCard } from '@/types/card';
import { GermanCompareCard } from '@/types/cardDE';

interface CompareBarProps {
  selectedCards: (CreditCard | GermanCompareCard)[];
  onRemoveCard: (id: string) => void;
  onCompare: () => void;
  onClear: () => void;
  labels?: {
    title: string;
    clear: string;
    compare: string;
  };
}

export function CompareBar({ 
  selectedCards, 
  onRemoveCard, 
  onCompare, 
  onClear,
  labels = {
    title: 'Vergleichen',
    clear: 'Zurücksetzen',
    compare: 'Karten vergleichen'
  }
}: CompareBarProps) {
  if (selectedCards.length === 0) return null;

  return (
    <div 
      className="fixed bottom-0 left-0 right-0 z-50 bg-white border-t border-gray-200 shadow-lg"
      style={{ 
        paddingBottom: 'env(safe-area-inset-bottom)',
        transform: 'translateZ(0)',
        WebkitTransform: 'translateZ(0)'
      } as React.CSSProperties}
    >
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-4">
        <div className="flex items-center justify-between gap-4">
          <div className="flex items-center gap-4 flex-1 overflow-x-auto">
            <span className="text-gray-900 whitespace-nowrap">
              {labels.title} ({selectedCards.length}/3)
            </span>
            <div className="flex gap-2">
              {selectedCards.map((card) => (
                <div
                  key={card.id}
                  className="flex items-center gap-2 bg-blue-50 border border-blue-200 rounded-lg px-3 py-2 whitespace-nowrap"
                >
                  <span className="text-gray-900 text-sm">{card.name}</span>
                  <button
                    onClick={() => onRemoveCard(card.id)}
                    className="text-gray-500 hover:text-gray-700"
                    aria-label={`${card.name} aus Vergleich entfernen`}
                  >
                    <X className="w-4 h-4" />
                  </button>
                </div>
              ))}
            </div>
          </div>
          <div className="flex items-center gap-2 flex-shrink-0">
            <Button variant="outline" onClick={onClear}>
              {labels.clear}
            </Button>
            <Button
              onClick={onCompare}
              disabled={selectedCards.length < 2}
              className="gap-2 bg-gradient-to-r from-blue-600 to-blue-700 hover:from-blue-700 hover:to-blue-800"
            >
              {labels.compare}
              <ArrowRight className="w-4 h-4" />
            </Button>
          </div>
        </div>
      </div>
    </div>
  );
}
